const styles = {
  global: {
    "html, body, #root": {
      h: "100%",
    },
    "body, p, span, a": {
      fontFamily: "inter",
      color: "black",
      fontSize: "12px",
      lineHeight: "14.5px",
      fontWeight: 500,
    },
    ".infinite-scroll-component__outerdiv": {
      width: "100%",
    },
  },
};

export default styles;
